<template>
  <div>
    <!--
    <p>menuOpen: {{ menuOpen }}</p>
    <p>entity: {{ entity }}</p>
    <p>{{ item }}</p>
    -->
    <v-dialog
      v-model="menuOpen" 
      persistent
      max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ title }}
          </span>
        </v-card-title>
        <template v-if="showInvitation">
          <v-card-text>
            <v-flex 
              class="mb-3"
              xs12
              v-html="$t('general.messages.invitation',{email:$t('site.email')})"/>
            <v-flex xs12>
              <v-text-field
                :label="$t(`entity.${entity}.invitation.label`)"
                :placeholder="$t(`entity.${entity}.invitation.placeHolder`)"
                v-model="invitationValue"
                type="text" 
                prepend-icon="report"
              />
            </v-flex>
            <v-flex 
              v-if="invitationValueMessage"
              class="mb-3 red--text"
              xs12
              v-html="$t('general.messages.invitation_'+invitationValueMessage)"/>
            <v-flex xs12>
              <v-btn 
                flat 
                class="primary"
                @click.native="checkInvitation">{{ $t('general.checkInvitation') }}</v-btn>
              <v-btn 
                flat
                class="default"
                @click.native="emitMenuOpen(!menuOpen)">{{ $t('general.cancel') }}</v-btn>
            </v-flex>
          </v-card-text>
        </template>
        <template v-else>
          <v-card-text>
            <v-container>
              <v-layout wrap>
                <template 
                  v-for="field in model" 
                  v-if="!['hidden','object','array'].includes(field.type)">
                  <v-flex 
                    :class="{xs12: !field.columns || field.columns === 1, xs6: field.columns === 2}" 
                    :key="field.name" >
                    <!-- DATE -->
                    <template v-if="field.type === 'date'">
                      <BaseFormDate
                        :key="field.name"
                        :key-field="field.name"
                        :value.sync="data[field.name]"
                        :field="field" 
                        :entity="entity"
                        :prepend-icon="field.icon"/>
                    </template>
                    <!-- HOUR -->
                    <template v-else-if="field.type === 'hour'">
                      <BaseFormHour
                        :key="field.name"
                        :key-field="field.name"
                        :value.sync="data[field.name]"
                        :field="field" 
                        :entity="entity"
                        :prepend-icon="field.icon"/>
                    </template>
                    <!-- IMAGE -->
                    <template v-else-if="field.type === 'image'">
                      <div class="input-group input-group--placeholder input-group--text-field primary--text">
                        <label>{{ $t(`entity.${entity}.${field.name}.label`) }}</label>
                      </div>
                      <BaseFormImage 
                        v-validate="field.validation"
                        :key="field.name"
                        :entity="entity"
                        :item="item"
                        :value.sync="data[field.name]"
                        :field="field.name" 
                        :uploading="field.uploading" 
                        :percentage="parseInt(field.percentage)"
                        :prepend-icon="field.icon" />
                    </template>
                    <!-- SELECT -->
                    <template v-else-if="field.type === 'select'">
                      <v-autocomplete
                        v-validate="field.validation" 
                        v-model="data[field.name]"
                        :key="field.name"
                        :name="field.name"
                        :items="optionsToTexts(field.name, field.options)"
                        :label="$t(`entity.${entity}.${field.name}.label`)"
                        :error="hasError(field.name)"
                        :error-messages="getError(field.name)"
                        :prepend-icon="field.icon"
                        :disabled="item && !field.allowEdit"
                        item-text="text"
                        item-value="value" />
                    </template>
                    <!-- AUTOCOMPLETE -->
                    <template v-else-if="field.type === 'autocomplete'">
                      <BaseFormSelect
                        :ref="field.name"
                        :entity="entity"
                        :field="field" 
                        :item="item"
                        :value.sync="data[field.name]"/>
                    </template>
                    <!-- AUTOCOMPLETE SEARCH -->
                    <template v-else-if="field.type === 'autocompleteClub'">
                      <BaseFormSelectClub
                        :ref="field.name"
                        :entity="entity"
                        :field="field" 
                        :item="item"
                        :value.sync="data[field.name]"/>
                    </template>
                    <!-- TEXTAREA -->
                    <template v-else-if="field.type === 'textarea'">
                      TO CHANGE
                      <textarea 
                        v-validate="field.validation" 
                        v-model="data[field.name]"
                        :key="field.name"
                        :name="field.name" 
                        :placeholder="$t(`entity.${entity}.${field.name}.placeHolder`)"
                        :prepend-icon="field.icon"
                        class="form-control" 
                        rows="10"/>
                    </template>
                    <!-- CHECKBOX -->
                    <template v-else-if="field.type === 'checkbox'">
                      TO CHANGE
                      <input  
                        v-validate="field.validation" 
                        v-model="data[field.name]"
                        :key="field.name"
                        :name="field.name" 
                        :type="field.type" 
                        :placeholder="$t(`entity.${entity}.${field.name}.placeHolder`)"
                        :prepend-icon="field.icon"
                        class="form-control" >
                    </template>
                    <!-- OTHERS -->
                    <template v-else>
                      <v-text-field
                        v-validate="field.validation" 
                        v-model="data[field.name]"
                        :key="field.name"
                        :name="field.name"
                        :type="field.type" 
                        :label="$t(`entity.${entity}.${field.name}.label`)"
                        :placeholder="$t(`entity.${entity}.${field.name}.placeHolder`)"
                        :error="hasError(field.name)"
                        :error-messages="getError(field.name)"
                        :disabled="item && !field.allowEdit"
                        :prepend-icon="field.icon"
                      />
                    </template>
                  </v-flex>
                </template>
              </v-layout>
              <p 
                v-show="formError"
                class="control-label red--text" >
                {{ formError }}
              </p>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn 
              flat
              class="default"
              @click.native="emitMenuOpen(!menuOpen)">{{ $t('general.cancel') }}</v-btn>
            <v-btn 
              :disabled="errors.any()"
              flat 
              class="primary"
              @click.native="submit">{{ $t('general.save') }}</v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import BaseFormDate from '@/components/Base/FormFields/BaseFormDate'
import BaseFormHour from '@/components/Base/FormFields/BaseFormHour'
import BaseFormImage from '@/components/Base/FormFields/BaseFormImage'
import BaseFormSelect from '@/components/Base/FormFields/BaseFormSelect'
import BaseFormSelectClub from '@/components/Base/FormFields/BaseFormSelectClub'
import ClubsLib from '@/lib/data/clubs'
import bus from '@/components/Base/bus'
import { mapState } from 'vuex'
const debug = require('debug')('OD::BaseFormModal')

export default {
  name: 'BaseFormModal',
  components: { BaseFormDate, BaseFormHour, BaseFormImage, BaseFormSelect, BaseFormSelectClub },
  props: {
    entity: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      default: null,
    },
    model: {
      type: Array,
      required: true,
    },
    allowAnonymous: {
      type: Boolean,
      default: false,
    },
    menuOpen: {
      type: Boolean,
      required: true,
    },
    needInvitation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: {},
      formError: '',
      processing: false,
      showInvitation: false,
      invitationValue: '',
      invitationValueMessage: '',
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
    }),
    submitButton() {
      if (this.item) {
        return this.$t('general.update')
      } else {
        return this.$t('general.add')
      }
    },
    title() {
      if (this.item) {
        return this.$t(`page.${this.entity}.form.title.edit`)
      } else {
        return this.$t(`page.${this.entity}.form.title.create`)
      }
    },
  },
  watch: {
    menuOpen() {
      this.chargeData()
    },
    invitationValue() {
      this.invitationValueMessage = ''
    },
  },
  created() {
    debug('created')
    this.chargeData()
  },
  beforeDestroy() {
    this.data = {}
  },
  mounted() {},
  methods: {
    chargeData() {
      debug('chargeData', this.item, this.needInvitation)
      if (!this.item && this.needInvitation) {
        this.showInvitation = true
      }
      if (this.menuOpen) {
        this.model.map(property => {
          Vue.set(this.data, property.name, this.item ? this.item[property.name] : null)
        })
        debug('YYY', this.data)
      } else {
        this.data = {}
      }
    },
    hasError(key) {
      return !!this.errors.first(key)
    },
    getError(key) {
      return this.errors.first(key) ? [this.errors.first(key)] : []
    },
    optionsToTexts(key, options) {
      return options.map(option => {
        return {
          value: option,
          text: this.$t(`entity.${this.entity}.${key}.options.${option}`),
        }
      })
    },
    emitMenuOpen(menuOpen) {
      this.$emit('update:menuOpen', menuOpen)
    },
    async submit() {
      let validChilds = true
      for (const child in this.$refs) {
        if (this.$refs[child][0].$validator) {
          const valid = await this.$refs[child][0].$validator.validateAll()
          if (!valid) {
            validChilds = valid
          }
        }
      }
      const valid = await this.$validator.validateAll()
      bus.$emit('validate')
      if (valid && validChilds) {
        if (this.item) {
          this.$emit('onUpdate', this.data, this.item)
        } else {
          this.$emit('onAdd', this.data)
        }
        if (!this.formError) {
          this.emitMenuOpen(false)
        }
      }
    },
    async checkInvitation() {
      // 1VjJrUjZAbIDfsxlf5GT
      const validateCodeStatus = await ClubsLib.validateInvitationCode(this, this.currentUser, {
        invitationCode: this.invitationValue,
      })
      debug('validateCodeStatus', validateCodeStatus)
      switch (validateCodeStatus) {
        case 'ok':
          this.showInvitation = false
          this.invitationValueMessage = ''
          break
        default:
          this.invitationValueMessage = validateCodeStatus
          break
      }
    },
  },
}
</script>

<style>
</style>
